import React from "react";
import InstructionNavigation from "./instructionsNabar";
import "./instructionNavbar.scss";

interface Step {
  title: string;
  instructions: string[];
}

interface InstructionStepProps {
  title: string;
  instructions: string[];
}

const alphabet = ["A", "B", "C", "D", "E", "F", "G","H","I"];

const InstructionStep: React.FC<InstructionStepProps> = ({
  title,
  instructions,
}) => (
  <div className="instruction-step">
    <p className="instruction-title">{title}</p>
    <ol className="instruction-list">
      {instructions.map((instruction, index) => (
        <li key={index}>{instruction}</li>
      ))}
    </ol>
  </div>
);

const Instruction: React.FC = () => {
  const steps: Step[] = [
    {
      title: "Registration",
      instructions: [
        'Look for the "Register now" link and click on it.',
        "Fill the required information accurately, including your name, email address, and other details as prompted.",
        "You will receive an email to create a password.",
        "Create a strong password to secure your account.",
        "Once done, you are ready to access the PeerEase tool.",
      ],
    },
    {
      title: "Recommended Browser",
      instructions: [
        'Use Google Chrome (latest version) for the best PeerEase experience and performance.',
      ],
    },
    {
      title: "Logging In",
      instructions: [
        "After successfully registering, log in to your account using the email address and password you provided during registration.",
        "Upon logging in, you'll be directed to your dashboard.",
      ],
    },
    {
      title: "Uploading a Manuscript",
      instructions: [
        'On your dashboard, locate the "SUBMIT NEW ARTICLE" button at the top right corner.',
        "Click on it to initiate the manuscript upload process.",
        "Follow the instructions provided to upload your manuscript file.",
        "Ensure that your manuscript adheres to the formatting and submission guidelines provided in the pre-requisite document.",
      ],
    },
    {
      title: "File Upload Support",
      instructions: [
        "In case you encounter any issues during the file upload process, don't worry!",
        "Our support team will be automatically intimated in case of any manuscript upload failure. They will clean up the uploaded manuscript via mail, which the author can upload it to the system. This will be done within 2 business days.",
      ],
    },
    {
      title: "Peer Review Process",
      instructions: [
        "Once your manuscript is uploaded successfully, it will undergo the peer review process.",
        "Expert reviewers in your field will assess the quality, significance, and originality of your work.",
        "You'll receive notifications and updates regarding the progress of your manuscript through the peer review system.",
      ],
    },
    {
      title: "Masking Author Information",
      instructions: [
        "Author personal information will be hidden if it appears in the front matter. ",
        "If it is present in the body matter, the Editor must hide it using the masking functionality.",
        "Step-by-step instructions are available in the iAuthor User Manual.",
      ],
    },
    {
      title: "Revisions",
      instructions: [
        "Upload the revised version of your manuscript following the same process as initial submission.",
        "Review the comments and suggestions provided by the reviewers carefully.",
        "Make necessary revisions to address the reviewers' comments and improve the quality of your manuscript.",
        "Upload the revised version of your manuscript following the same process as initial submission.",
      ],
    },
    {
      title: "Production",
      instructions: [
        "Upon successful completion of the peer review process and any necessary revisions, your manuscript will be accepted for publication.",
        "Congratulations! Your work will soon be available to contribute to the advancement of knowledge in your field.",
      ],
    },
  ];

  return (
    <div>
      <InstructionNavigation />
      <div className="instruction-container">
        <h1 className="instruction-heading">Quick Reference Guide</h1>
        {steps.map((step, index) => (
          <InstructionStep
            key={index}
            title={`${alphabet[index]}. ${step.title}`}
            instructions={step.instructions}
          />
        ))}
      </div>
      <p className="instruction-support">
        If you have any further questions or need assistance, don't hesitate to
        reach out to our support team via{" "}
        <a href="mailto:product.support@integra.co.in" className="support-link">
          product.support@integra.co.in
        </a>
        . Happy publishing!
      </p>
    </div>
  );
};

export default Instruction;
